var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataanalytic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1579.61 1699.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4b6cb4;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "527.74 1075.51 384.45 1076.58 381.39 667.19 524.67 666.12 527.74 1075.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "722.19 1074.05 578.92 1075.12 575.26 587.26 718.54 586.19 722.19 1074.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "930.3 1072.5 787.01 1073.57 782.63 486.79 925.92 485.72 930.3 1072.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1141.82 1070.91 998.52 1071.99 993.5 399.91 1136.79 398.84 1141.82 1070.91"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 350.84,
    y: 1063.99,
    width: 824.72,
    height: 38.27,
    transform: "translate(-8.08 5.74) rotate(-.43)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1012.25 1440.4 1031.72 1699.23 679.24 1465.45 992.78 1181.56 1012.25 1440.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M789.8,0C353.6,0,0,353.61,0,789.8c0,380.52,269.11,698.15,627.39,773.05.95-65.21,2.73-130.45,3.81-195.64-253.66-69.52-440.07-301.68-440.07-577.4,0-330.64,268.04-598.68,598.68-598.68s598.69,268.04,598.69,598.68c0,265.81-173.25,491.12-412.97,569.27,12.65,62.78,25.37,125.56,37.9,188.37,327.28-96.45,566.18-399.12,566.18-757.64C1579.61,353.61,1226,0,789.8,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataanalytic);
export default __webpack_public_path__ + "static/media/data analytic.465e854a3a2cbaf8ae0f5ac4c1641a8f.svg";
export { ForwardRef as ReactComponent };